<template>
    <v-card class="page-header mb-4" elevation="1">
        <div class="page-header__top">
            <div class="page-header__title">
                <v-icon v-if="icon" color="orange" class="mr-2">{{ icon }}</v-icon>
                <span class="text-h6 font-weight-bold">{{ title }}</span>
                <slot name="title-append" />
            </div>
            <div v-if="$slots.actions" class="page-header__actions">
                <slot name="actions" />
            </div>
        </div>
        <div v-if="$slots.default" class="page-header__body">
            <slot />
        </div>
    </v-card>
</template>

<script>
    export default {
        name: 'PageHeader',
        props: {
            title: {
                type: String,
                required: true
            },
            icon: {
                type: String,
                default: null
            }
        }
    }
</script>

<style scoped>
    .page-header {
        border-left: 4px solid #ff9800 !important;
    }

    .page-header__top {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: 8px 16px;
        padding: 12px 16px;
    }

    .page-header__title {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 8px;
    }

    .page-header__actions {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
        gap: 8px;
    }

    .page-header__body {
        border-top: 1px solid rgba(0, 0, 0, 0.08);
    }
</style>
